// extracted by mini-css-extract-plugin
export default {"padding":"padding_padding__2Ospe"};